import { AngularFirestore, DocumentReference } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { Product } from "../product/product.model";
import { Venue } from "./venue.model";
import * as moment from "moment";
import { MenuBuilder, MenuBuilderState } from "../menu/menu.builder";
import { City } from "../city/city.model";
import { environment } from "src/environments/environment";
export class VenueBuilder {
  public reference: DocumentReference;
  public city: DocumentReference;
  public cityName: string;
  public cityState: string;
  public cityTimezone: string;
  public name: string;
  public isActive: boolean;
  public rank: number;
  public thumbnail: string;
  public description: string;
  public image: string;
  public redirect: boolean;
  public redirectUrl: string;
  public createdBy: string;
  public editedBy: string;
  public products$: Observable<Product[]>;
  public products: Product[];
  public menu: MenuBuilder;
  public isTopDrinksActive: boolean;
  public totalActivePasses: number;
  public totalPasses: number;
  public isBannerActive: boolean;
  public bannerImage: string;
  public isBannerRedirectActive: boolean;
  public bannerRedirectUrl: string;
  public hideTicketOrders: boolean;
  constructor() {
    this.isTopDrinksActive = true;
  }

  loadAPIResponse(data: any, db: AngularFirestore) {
    this.reference = db.doc(`${environment.venues}/${data.id}`).ref;
    this.city = db.doc(`${environment.cities}/${data.city}`).ref;
    this.cityTimezone = data.cityTimezone;
    this.isTopDrinksActive = data.isTopDrinksActive ?? true;
    this.cityName = data.cityName;
    this.cityState = data.cityState;
    this.name = data.name;
    this.isActive = data.isActive;
    this.rank = data.rank;
    this.thumbnail = data.thumbnail;
    this.description = data.description;
    this.image = data.image;
    this.redirect = data.redirect;
    this.redirectUrl = data.redirectUrl;
    this.createdBy = data.createdBy;
    this.editedBy = data.editedBy;
    this.bannerImage = data.bannerImage ?? "";
    this.isBannerActive = data.isBannerActive ?? false;
    this.isBannerRedirectActive = data.isBannerRedirectActive ?? false;
    this.bannerRedirectUrl = data.bannerRedirectUrl ?? "";
    this.totalActivePasses = data.totalActivePasses ?? 0;
    this.totalPasses = data.totalPasses ?? 0;
    this.menu = data.menu
      ? new MenuBuilder(MenuBuilderState.LoadingMenu, this.cityTimezone).load(
          data.menu
        )
      : null;
    this.hideTicketOrders = data.hideTicketOrders ?? false;
    return this;
  }

  get hasReference(): boolean {
    return this.reference != null;
  }

  edit(venue: Venue) {
    this.reference = venue.reference;
    this.city = venue.city;
    this.cityName = venue.cityName;
    this.cityTimezone = venue.cityTimezone;
    this.isTopDrinksActive = venue.isTopDrinksActive;
    this.cityState = venue.cityState;
    this.name = venue.name;
    this.isActive = venue.isActive;
    this.rank = venue.rank;
    this.thumbnail = venue.thumbnail;
    this.description = venue.description;
    this.image = venue.image;
    this.redirect = venue.redirect;
    this.redirectUrl = venue.redirectUrl;
    this.createdBy = venue.createdBy;
    this.bannerRedirectUrl = venue.bannerRedirectUrl;
    this.isBannerRedirectActive = venue.isBannerRedirectActive;
    this.editedBy = venue.editedBy;
    this.totalActivePasses = venue.totalActivePasses;
    this.totalPasses = venue.totalPasses;
    this.bannerImage = venue.bannerImage;
    this.isBannerActive = venue.isBannerActive;
    this.hideTicketOrders = venue.hideTicketOrders;
    this.menu = venue.menu
      ? new MenuBuilder(MenuBuilderState.EditingMenu, this.cityTimezone).edit(
          venue.menu
        )
      : null;
    return this;
  }

  setCity(city: City) {
    this.city = city.reference;
    this.cityName = city.name;
    this.cityTimezone = city.timezone;
    this.cityState = city.state;
    return this;
  }

  setCreatedBy(creator: string) {
    const date = " (" + moment().format("MM/DD/YY") + ")";
    this.createdBy = creator + date;
    return this;
  }

  setEditedBy(editor: string) {
    const date = " (" + moment().format("MM/DD/YY") + ")";
    this.editedBy = editor + date;
  }

  setRank(rank: number) {
    this.rank = rank;
    return this;
  }

  create(
    form: any,
    image: string,
    bannerImage: string,
    rank: number
  ): VenueBuilder {
    this.name = form.name;
    this.isActive = form.isActive;
    this.image = image;
    this.redirect = form.redirect;
    this.isBannerActive = form.isBannerActive;
    this.bannerImage = bannerImage;
    this.redirectUrl = this.redirect ? form.redirectUrl : null;
    this.description = form.description;
    this.thumbnail = form.thumbnail;
    this.rank = rank;
    this.totalActivePasses = 0;
    this.isBannerRedirectActive = form.isBannerRedirectActive;
    this.bannerRedirectUrl = form.bannerRedirectUrl;
    this.totalPasses = 0;
    this.hideTicketOrders = false;
    return this;
  }

  build(): Venue {
    return new Venue(this);
  }
}
